import { render, staticRenderFns } from "./work_item_popover.vue?vue&type=template&id=2cb4a4d8"
import script from "./work_item_popover.vue?vue&type=script&lang=js"
export * from "./work_item_popover.vue?vue&type=script&lang=js"
import style0 from "./work_item_popover.vue?vue&type=style&index=0&id=2cb4a4d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports